import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { requestGet } from '../api/request';
import { GET_DICTIONARY, GET_LIST_LANGUAGE } from '../api/url';
import { getToLocaleStorage } from './Partials/Helper';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-notifications/lib/notifications.css';
import Home from './Home/Home';
import Header from './Partials/Header';
import Footer from './Partials/Footer';
import Contacts from './Contacts/Contacts';
import EventById from './Event/EventById';
import EventGroup from './Event/EventGroup';
import MainLoader from './Partials/MainLoader';
import President from './President/President';
import Biography from './President/Biography';
import Power from './President/Power';
import Tajikistan from './Tajikistan/Tajikistan';
import * as actions from '../redux/actions';
import Symbols from './Symbols/Symbols';
import Emblems from './Symbols/Emblems';
import Flags from './Symbols/Flags';
import Hymns from './Symbols/Hymns';
import Moneys from './Tajikistan/Moneys';
import Books from './Books/Books';
import BooksOfTheLeader from './Books/BooksOfTheLeader';
import BooksAboutTheLeader from './Books/BooksAboutTheLeader';
import ExecutiveOffice from './ExecutiveOffice/ExecutiveOffice';
import Chief from './ExecutiveOffice/Chief';
import Assistants from './ExecutiveOffice/Assistants';
import Press from './ExecutiveOffice/Press';
import Government from './Government/Government';
import Head from './Government/Head';
import Presidium from './Government/Presidium';
import Members from './Government/Members';
import Sessions from './Government/Sessions';
import EvMeetings from './Event/EvMeetings';
import EvSpeeches from './Event/EvSpeeches';
import EvCalls from './Event/EvCalls';
import EvTrips from './Event/EvTrips';
import EvDocuments from './Event/EvDocuments';
import EvMissives from './Event/EvMissives';
import EvTelegrams from './Event/EvTelegrams';
import EvGrMeetings from './Event/EvGrMeetings';
import EvGrSpeeches from './Event/EvGrSpeeches';
import EvGrDocuments from './Event/EvGrDocuments';
import EvGrForeignTrips from './Event/EvGrForeignTrips';
import EvGrDomesticTrips from './Event/EvGrDomesticTrips';
import EvGrMissives from './Event/EvGrMissives';
import EvGrTelegrams from './Event/EvGrTelegrams';
import EvGrCalls from './Event/EvGrCalls';
import Articles from './Articles/Articles';
import Constitutions from './Tajikistan/Constitutions';
import Search from './Search/Search';
import EventByTheme from './Event/EventByTheme';
import EvByThemeInteralPoliticts from './Event/EvByThemeInternalPoliticts';
import EvByThemeInternStruct from './Event/EvByThemeInternStruct';
import EvByThemeBiliteralRelations from './Event/EvByThemeBiliteralRelations';
import Decrees from './Documents/Decrees';
import Resolutions from './Documents/Resolutions';
import Directives from './Documents/Directives';
import Commands from './Documents/Commands';
import SearchByRegion from './Search/SearchByRegion';
import EvNews from './Event/EvNews';
import EvGrNews from './Event/EvGrNews';
import GovernmentById from './Government/GovernmentById';
import SearchByCountry from './Search/SearchByCountry';
import Films from './Films/Films';
import FilmById from './Films/FilmById';
import EventByNodeId from './Event/EventByNodeId';
import Gallery from './Gallery/Gallery';
import Photos from './Gallery/Photos';
import Videos from './Gallery/Videos';
import Awards from './President/Awards';
import AllDocuments from './Documents/AllDocuments';
import PresSymbols from './President/Symbols';
import Standart from './President/Standart';
import Sign from './President/Sign';
import Chronicles from './Films/Chronicles';
import Filmography from './Films/Filmography';
import Declaration from './Tajikistan/Declaration';
import PeacemakingExperience from './Tajikistan/PeacemakingExperience';
import Strengthening from './Tajikistan/Strengthening';
import JudicialPower from './Tajikistan/JudicialPower';
import EventByEachTheme from './EventByTheme/EventByEachTheme';
import Leader from './Leader/Leader';
import GalleryById from './Gallery/GalleryById';
import Regulations from './ExecutiveOffice/Regulations';
import Structure from './ExecutiveOffice/Structure';
import Constitution from './Constitution/Constitution';
import VidoeGalleryById from './Gallery/VideoGalleryById';
import PageNotFound from './Partials/PageNotFound';

const Main = () => {
  const listLanguage = useSelector(
    (state) => state.languageReducer.list_language,
  );
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const dispatch = useDispatch();

  const [ready, setReady] = useState(false);

  const getListLanguage = async () => {
    const response = await requestGet(GET_LIST_LANGUAGE);
    if (response.success) {
      dispatch(actions.setListLanguage(response.data));
    }
  };

  const setDefaultLanguage = (name) => {
    for (let i = 0; i < listLanguage.length; i += 1) {
      if (listLanguage[i].name === name) {
        dispatch(actions.setCurrentLanguage(listLanguage[i]));
      }
    }
  };

  const getDictionary = async () => {
    const response = await requestGet(GET_DICTIONARY, {
      'language_id': currentLanguage.id,
    });

    if (response.success) {
      dispatch(actions.setDictionary(response.data.messages));
    }
  };

  const setFontSize = async () => {
    if (localStorage.getItem('font_size')) {
      dispatch(actions.setFontSize(localStorage.getItem('font_size')));
    }
  };

  useEffect(() => {
    if (typeof listLanguage === 'undefined') {
      getListLanguage();
    }

    if (
      typeof listLanguage !== 'undefined'
      && !localStorage.getItem('current_language')
    ) {
      setDefaultLanguage('tj');
      document.documentElement.lang = 'tj';
      document.dir = 'ltr';
    }

    if (
      typeof listLanguage !== 'undefined'
      && localStorage.getItem('current_language')
    ) {
      setDefaultLanguage(localStorage.getItem('current_language'));
      document.documentElement.lang = localStorage.getItem('current_language');
      if (getToLocaleStorage('current_language') !== 'ae') {
        document.dir = 'ltr';
      } else {
        document.dir = 'rtl';
      }
    }
  }, [listLanguage]);

  useEffect(() => {
    if (typeof currentLanguage !== 'undefined') {
      getDictionary();
      localStorage.setItem('current_language', currentLanguage.name);
    }
  }, [currentLanguage]);

  useEffect(() => {
    if (typeof dictionary !== 'undefined') {
      setReady(true);
      setFontSize();
    }
  });

  useEffect(() => {
    if (!localStorage.getItem('font_size')) {
      localStorage.setItem('font_size', 24);
    }

    if (localStorage.getItem('font_size')) {
      setFontSize();
    }
  }, [fontSize]);

  return (
    <BrowserRouter>
      {ready === true ? (
        <>
          <Header />
          <Routes>
            {/* Start Home page */}
            <Route path="/" element={<Home />}>
              <Route index element={<EvNews />} />
              <Route path="news" element={<EvNews />} />
              <Route path="meetings" element={<EvMeetings />} />
              <Route path="speeches" element={<EvSpeeches />} />
              <Route path="trips" element={<EvTrips />} />
              <Route path="documents" element={<EvDocuments />} />
              <Route path="missives" element={<EvMissives />} />
              <Route path="telegrams" element={<EvTelegrams />} />
              <Route path="calls" element={<EvCalls />} />
            </Route>
            {/* End Home page */}

            <Route path="/contacts" element={<Contacts />} />

            {/* Start Event */}
            <Route path="/event/:groupName/:eventId" element={<EventById />} />
            <Route
              path="/event/:groupName/:groupDocuments/:eventId"
              element={<EventById />}
            />
            <Route
              path="/event_by_theme/:groupName/:groupCountry/:eventId"
              element={<EventById />}
            />

            <Route path="/event" element={<EventGroup />}>
              <Route index element={<EvGrNews />} />
              <Route path="news" element={<EvGrNews />} />
              <Route path="meetings" element={<EvGrMeetings />} />
              <Route path="speeches" element={<EvGrSpeeches />} />
              <Route path="domestic_trips" element={<EvGrDomesticTrips />} />
              <Route path="foreign_trips" element={<EvGrForeignTrips />} />
              <Route path="missives" element={<EvGrMissives />} />
              <Route path="telegrams" element={<EvGrTelegrams />} />
              <Route path="calls" element={<EvGrCalls />} />

              <Route path="/event/documents" element={<EvGrDocuments />}>
                <Route index element={<AllDocuments />} />
                <Route
                  path="/event/documents/all_documents"
                  element={<AllDocuments />}
                />
                <Route path="/event/documents/decrees" element={<Decrees />} />
                <Route path="/event/documents/commands" element={<Commands />} />
                <Route
                  path="/event/documents/resolutions"
                  element={<Resolutions />}
                />
                <Route
                  path="/event/documents/directives"
                  element={<Directives />}
                />
              </Route>
            </Route>

            <Route path="/event_by_theme" element={<EventByTheme />}>
              <Route index element={<EvByThemeInteralPoliticts />} />
              <Route
                path="internal_politics"
                element={<EvByThemeInteralPoliticts />}
              />
              <Route
                path="international_structures"
                element={<EvByThemeInternStruct />}
              />
              <Route
                path="bilateral_relations"
                element={<EvByThemeBiliteralRelations />}
              />
            </Route>

            <Route
              path="/event_by_theme/:politicGroup/:politicPath"
              element={<EventByEachTheme />}
            />
            <Route
              path="/event_by_theme/:politicGroup/:politicPath/page/:pageNum"
              element={<EventByEachTheme />}
            />
            {/* End Event */}

            {/* Start President page */}
            <Route path="/president" element={<President />}>
              <Route index element={<Power />} />
              <Route path="power" element={<Power />} />
              <Route path="biography" element={<Biography />} />
              <Route path="articles" element={<Articles />} />
              <Route path="awards" element={<Awards />} />

              <Route path="/president/symbols" element={<PresSymbols />}>
                <Route index element={<Standart />} />
                <Route
                  path="/president/symbols/standart"
                  element={<Standart />}
                />
                <Route path="/president/symbols/sign" element={<Sign />} />
              </Route>

              <Route path="/president/films" element={<Films />}>
                <Route index element={<Chronicles />} />
                <Route
                  path="/president/films/chronicles"
                  element={<Chronicles />}
                />
                <Route
                  path="/president/films/filmography"
                  element={<Filmography />}
                />
              </Route>

              <Route path="/president/books" element={<Books />}>
                <Route index element={<BooksOfTheLeader />} />
                <Route
                  path="/president/books/books_of_the_president"
                  element={<BooksOfTheLeader />}
                />
                <Route
                  path="/president/books/books_about_the_president"
                  element={<BooksAboutTheLeader />}
                />
              </Route>
            </Route>

            <Route
              path="/president/films/:filmGroup/:filmId"
              element={<FilmById />}
            />
            {/* End President page */}

            {/* Start Leader page */}
            <Route path="/leader_of_the_nation" element={<Leader />} />
            {/* End Leader page */}

            {/* Start Tajikistan page */}
            <Route path="/tajikistan" element={<Tajikistan />}>
              <Route index element={<Declaration />} />
              <Route
                path="proclamation_of_state_independence"
                element={<Declaration />}
              />
              <Route path="constitution" element={<Constitutions />} />
              <Route
                path="tajik_peacemaking_experience"
                element={<PeacemakingExperience />}
              />
              <Route
                path="strengthening_of_state_independence"
                element={<Strengthening />}
              />
              <Route path="judicial_power" element={<JudicialPower />} />
              <Route path="moneys" element={<Moneys />} />
            </Route>
            {/* End Tajikistan page */}

            {/* Start Symbols Page */}
            <Route path="/symbols" element={<Symbols />}>
              <Route index element={<Flags />} />
              <Route path="flags" element={<Flags />} />
              <Route path="emblems" element={<Emblems />} />
              <Route path="hymns" element={<Hymns />} />
            </Route>
            {/* End Symbols page */}

            {/* Start Constitution page */}
            <Route path="constitution" element={<Constitution />} />
            {/* End Constitution page */}

            {/* Start Executive office */}
            <Route path="executive_office" element={<ExecutiveOffice />}>
              <Route index element={<Chief />} />
              <Route path="chief_of_staff" element={<Chief />} />
              <Route
                path="regulations"
                element={<Regulations />}
              />
              <Route
                path="structure"
                element={<Structure />}
              />
              <Route
                path="assistants_to_the_president"
                element={<Assistants />}
              />
              <Route path="press_service" element={<Press />} />
            </Route>
            {/* End Executive office */}
            {/* Start Government */}
            <Route path="government" element={<Government />}>
              <Route index element={<Head />} />
              <Route path="head_of_government" element={<Head />} />
              <Route path="government_presidium" element={<Presidium />} />
              <Route path="government_members" element={<Members />} />
              <Route path="government_sessions" element={<Sessions />} />
            </Route>
            <Route
              path="/government/:govName/:govId"
              element={<GovernmentById />}
            />
            <Route path="/government/government_sessions/:eventId" element={<EventById />} />
            {/* End Government */}
            {/* Start Search routes */}
            <Route path="/search" element={<Search />} />
            <Route path="/search_by_region" element={<SearchByRegion />} />
            <Route path="/search_by_country" element={<SearchByCountry />} />
            {/* End Search Routes */}
            <Route path="/node/:nodeId" element={<EventByNodeId />} />
            <Route
              path="/event/:nodeGroup/node/:nodeId"
              element={<EventByNodeId />}
            />

            <Route path="/gallery" element={<Gallery />}>
              <Route index element={<Photos />} />
              <Route path="photoreport" element={<Photos />} />
              <Route path="videoreport" element={<Videos />} />
            </Route>
            <Route path="/gallery/photoreport/:galleryId" element={<GalleryById />} />
            <Route path="/gallery/videoreport/:galleryId" element={<VidoeGalleryById />} />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Footer />
        </>
      ) : (
        <MainLoader />
      )}
    </BrowserRouter>
  );
};

export default Main;
